import React from 'react';
import { PieceStatus } from '../../types';
import { DS } from '../../theme/DesignSystem';
import { clsx } from 'clsx';
import { getStatusColor } from '../../domain';

interface StatusBadgeProps {
  status: PieceStatus;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  return (
    <span className={clsx(DS.status.base, getStatusColor(status), className)}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-60"></span>
      {status}
    </span>
  );
};